import { IEmailFollowUp } from '../interfaces/email-follow-up';
import * as baseAdapter from './baseAdapter';

export const queryEmailFollowUps = async () => {
  const ret = await baseAdapter.get<IEmailFollowUp[]>('/emailFollowUp/getAll');
  return ret;
};

export const addEmailFollowUp = async (data: IEmailFollowUp) => {
  const ret = await baseAdapter.post<IEmailFollowUp>(
    '/emailFollowUp/create',
    data,
  );
  return ret;
};

export const editEmailFollowUp = async (data: IEmailFollowUp) => {
  const ret = await baseAdapter.put(
    `/emailFollowUp/update/${data.countryCode}`,
    data,
  );
  return ret;
};

export const deleteEmailFollowUp = async (id: string) => {
  const ret = await baseAdapter.deleteRequest(`/emailFollowUp/delete/${id}`);
  return ret;
};
